import type { FC } from 'react';
import Header from '@/components/UI/Header';
import { type LabelProps } from '@/components/UI/Label/Label';
import { LabelType } from '@/components/UI/Label/Label.tsx';
import { _isNil, _isNotBlank } from '@/littledash';
import type { Study } from '@/model/Study.model';
import { renderStudyClosureDate } from './StudyClosureDate.utils';
import StudyUsers from './Users';

interface StudyheaderProps {
  study: Study;
}

const Studyheader: FC<StudyheaderProps> = ({ study }) => {
  if (_isNil(study)) {
    return null;
  }
  const timezone = study.config?.timezone;
  const headerLabel: LabelProps | undefined = _isNotBlank(study.archived_at)
    ? {
        text: 'Completed',
        tooltip: `This study was completed on ${renderStudyClosureDate(study.completed_on, study.archived_at, timezone)}`,
        type: LabelType.Mild,
        icon: 'checkbox_thin',
      }
    : _isNotBlank(study.canceled_at)
      ? {
          text: 'Cancelled',
          tooltip: `This study was cancelled on ${renderStudyClosureDate(study.canceled_on, study.canceled_at, timezone)}`,
          type: LabelType.Info,
        }
      : undefined;
  return (
    <>
      <div className="ph4">
        <Header
          mainHeaderText={study.name}
          subHeaderText={study.code}
          asideComponent={() => <StudyUsers study={study} />}
          label={headerLabel}
        />
      </div>
    </>
  );
};

export default Studyheader;
